import { Dropdown, MenuProps } from "antd";
import { IHall, IObject } from "../App";



type HallSelectorProps = {
    object: IObject;
    disabled: boolean;

    selectedHall: IHall;
    onSelectHall: (hall: IHall) => void;
};

export function HallSelector(props: HallSelectorProps) {

    function buildHallItems() {
        let hallItems: MenuProps['items'] = [];
        for (const hall of props.object.halls) {
            hallItems.push({
                label: hall.name,
                key: hall.id,
            });
        }
                
        return hallItems;
    }

    return (
        <Dropdown.Button trigger={["click", "hover"]} style={{ width: '100%' }} menu={{items: buildHallItems(), onClick: (info) => {
            const hall = props.object.halls.find( (value) => {
                return value.id === Number.parseInt(info.key);
            });

            if(hall) {
                props.onSelectHall(hall);
            }
        }}} disabled={props.disabled}>
            {props.selectedHall.name}
        </Dropdown.Button>
    );
}
